import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';
import commonConfig from './commonConfig';
import useSessionId from '../utils/session/useSessionId';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: commonConfig.graphqlBaseUrl,
});

/**
 * @see https://stackoverflow.com/questions/64642948/is-there-a-way-to-name-graphql-requests-in-the-devtool-network-tab
 */
const namedLink = new ApolloLink((operation, forward) => {
  operation.setContext(() => {
    return {
      uri: `${commonConfig.graphqlBaseUrl}?${operation.operationName}`,
    };
  });
  return forward ? forward(operation) : null;
});

const sessionLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'session-id': useSessionId(),
    },
  };
});

const graphqlClientConfig = new ApolloClient({
  // eslint-disable-next-line no-undef
  connectToDevTools: process.env.NODE_ENV !== 'production',
  cache: new InMemoryCache(),
  link: ApolloLink.from([namedLink, sessionLink, httpLink]),
});

export default graphqlClientConfig;
